import { render, staticRenderFns } from "./corporate.vue?vue&type=template&id=08531216&scoped=true"
import script from "./corporate.vue?vue&type=script&lang=js"
export * from "./corporate.vue?vue&type=script&lang=js"
import style0 from "./corporate.vue?vue&type=style&index=0&id=08531216&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08531216",
  null
  
)

export default component.exports